export default __webpack_public_path__ + "static/media/paint.958826a2.png";